import { CLOUDINARY_INTEL_BASE_URL } from "@utils/enum";
import { Modal } from "react-bootstrap";
import { getProfileName, profileTypeEndPoint } from "@components/templates/Profile/ProfileHeader/profile-enum";
import { toast } from "react-toastify";
import axios from "axios";
import { useSelector } from "react-redux";
import { captureException } from "@sentry/react";

const GetInTouchLimit = ({ showGetInTouchPopup, handleGetInTouchClose, profileType, notifyCountry, blockAccessType, requestType }) => {
  const creditDetails = useSelector((state) => state.userDetails.creditDetails);
  const handleGetInTouchSubmit = (e) => {
    if (e) {
      handleGetInTouchClose(e);
    } else {
      handleGetInTouchClose();
    }
    const { user_active_plan } = creditDetails.data?.[0] ?? "";
    const planId = user_active_plan;
    const params = {
      planId,
      countries: notifyCountry ?? "",
      key: requestType ? requestType.split(" ").join("_").toLowerCase() : (getProfileName[profileType] ?? "Profile"),
    };
    axios
      .get(profileTypeEndPoint.getInTouch, { params })
      .then((res) => {
        if (!!res && !!res.data && !!res.data.status && res.data.status.toUpperCase() === "success".toUpperCase()) {
          toast.success(res.data.message, {
            position: blockAccessType === "feature" || blockAccessType === "connect" ? toast.POSITION.BOTTOM_RIGHT : toast.POSITION.BOTTOM_LEFT,
          });
        } else {
          toast.error(res.data.message ? res.data.message : "Something went wrong. Please try again later !!!", {
            position: blockAccessType === "feature" || blockAccessType === "connect" ? toast.POSITION.BOTTOM_RIGHT : toast.POSITION.BOTTOM_LEFT,
          });
        }
      })
      .catch((error) => {
        captureException(error);
        toast.success("Something went wrong. Please try again later !!!", {
          position: blockAccessType === "feature" || blockAccessType === "connect" ? toast.POSITION.BOTTOM_RIGHT : toast.POSITION.BOTTOM_LEFT,
        });
      });
  };
  return (
    <div>
      <Modal show={showGetInTouchPopup} onHide={(e) => handleGetInTouchClose(e)} centered contentClassName="tw-rounded-lg tw-min-w-[572px] tw-min-h-[280px] tw-border-0 tw-shadow-xl tw-overflow-hidden">
        <Modal.Header className="tw-border-b tw-py-2 tw-border-b-gray-200">
          <Modal.Title className="tw-text-xl tw-font-semibold tw-text-gray-800 w-100 tw-text-left">You have exhausted your daily search limit.</Modal.Title>
        </Modal.Header>

        <Modal.Body className="tw-flex tw-flex-col tw-gap-2 tw-text-center tw-px-4 tw-py-3">
          <div className="tw-relative tw-w-full tw-min-h-[152px] tw-rounded-lg tw-flex tw-items-center tw-justify-center">
            <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1684821201/intel/icons/orange-gradient-bg_x0rmp0.svg" className="tw-w-full tw-h-full tw-rounded-lg tw-object-cover" />
            <div className="tw-border tw-border-white tw-p-4 tw-absolute tw-rounded-xl tw-shadow-md">
              <span className="tw-text-orange-500">
                <img src={`${CLOUDINARY_INTEL_BASE_URL}/v1684478309/intel/icons/Lightning-alt_t9mkjb.svg`} />
              </span>
            </div>
          </div>

          <div className="tw-flex tw-flex-col tw-gap-1">
            <p className="tw-text-sm tw-font-semibold tw-text-gray-900">Connect with CSM to Upgrade your plan for Unlimited Searches</p>
            <p className="tw-text-sm tw-font-medium tw-text-gray-600">Or to make new searches visit the platform after 24hrs</p>
          </div>
        </Modal.Body>

        <Modal.Footer className="tw-border-0 tw-flex tw-justify-between tw-pt-0 tw-pb-4 sm:tw-pb-6">
          <button type="button" className="btn btn-secondary tw-py-2.5" onClick={handleGetInTouchClose}>
            Close
          </button>
          <button type="button" className="btn btn-primary trademo-new-btn" onClick={(e) => handleGetInTouchSubmit(e)}>
            Get in Touch
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default GetInTouchLimit;
